import { DashboardPickupRequestList, DashboardPickupRequestListSearch } from "../../../types/operations/pickupRequestDashboardInterface";
import { PickupRequestDashboardActionTypes, PickupRequestDashboardActions } from "../../actionTypes/operations/pickupRequestDashboradTypes";

export const getDashboardPickupRequestList = (payload: DashboardPickupRequestListSearch): PickupRequestDashboardActionTypes => ({
  type: PickupRequestDashboardActions.GET_PICKUP_REQUEST_DASHBOARD_LIST,
  payload
});

export const setDashboardPickupRequestList = (payload: Array<DashboardPickupRequestList>): PickupRequestDashboardActionTypes => ({
  type: PickupRequestDashboardActions.SET_PICKUP_REQUEST_DASHBOARD_LIST,
  payload
})

export const setDashboardPickupRequestListCount = (payload: number): PickupRequestDashboardActionTypes => ({
  type: PickupRequestDashboardActions.SET_PICKUP_REQUEST_DASHBOARD_PAGE_COUNT,
  payload
})

export const setPickupStatus = (payload: string): PickupRequestDashboardActionTypes => ({
  type: PickupRequestDashboardActions.SET_PICKUP_STATUS,
  payload
})